<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { VueCookieNext } from 'vue-cookie-next';
import { storeToRefs } from 'pinia';
import { useRouting } from '@/composables';
import { useAuthStore, useTenantStore } from '@/store';
import { TenantInterface } from '@/types/Auth';

const $routing = useRouting();
const tenantStore = useTenantStore();
const authStore = useAuthStore();
const tenant = ref({} as TenantInterface);
const { token, impersonateTenantToken, isSwitchTenant } = storeToRefs(authStore);

onMounted(() => init());

const init = async () => {
  if (isSwitchTenant.value) {
    tenant.value = impersonateTenantToken?.value?.guest_tenant;
  }
};

const onLeave = async () => {
  const tenantGuest = impersonateTenantToken?.value?.guest_tenant;
  VueCookieNext.removeCookie('tenant');
  const accessToken = VueCookieNext.getCookie('accessToken');
  authStore.setCookie('tenant', accessToken.tenant, token.value?.expires_in);

  await tenantStore.leaveTenant(tenantGuest.id);
  authStore.impersonateTenantToken = null;

  await authStore.getAuthUserProfile();
  $routing.router.push(`/admin`);

  await authStore.fetchAccessToken();
  await authStore.boot();
  document.body.classList.add('theme-admin');
};
</script>

<template>
  <div v-if="isSwitchTenant && tenant.name">
    <div class="tenant-banner flex justify-content-between h-2rem bg-yellow-light p-1 align-content-center">
      <div class="w-full flex align-items-center text-sm text-color-orange-dark">
        <AppButton
          v-if="!authStore.isImpersonating"
          type="link"
          color="yellow"
          text="Admin Panel"
          icon-left="arrow_back"
          style="height: 2rem"
          @click="onLeave"
        />
        <p v-else class="text-left font-bold ml-1" color="yellow">Viewing Tenant</p>
        <p class="white-space-nowrap ml-2 line-height-1">{{ tenant.name }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tenant-banner {
  & > div {
    max-width: 1440px;
    margin: 0 auto;
  }
}
</style>
